import { ReactElement } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from './Header/Header';
import { FaArrowRight } from 'react-icons/fa6';
import { IconWrapper } from '../../IconWrapper/IconWrapper';

import styles from './Widget.module.scss';

interface IWidgetProps {
  color: 'yellow' | 'blue' | 'violet' | 'green' | 'red' | 'orange';
  name: string;
  icon: ReactElement;
  values: { [x: string]: number };
  link: string;
  subtitle: string;
}

const Widget = ({ color, icon, name, values, link, subtitle }: IWidgetProps) => {
  const navigate = useNavigate();

  const getClassName = () => {
    switch (color) {
      case 'yellow':
        return styles.Yellow;
      case 'violet':
        return styles.Violet;
      case 'green':
        return styles.Green;
      case 'red':
        return styles.Red;
      case 'orange':
        return styles.Orange;
      default:
        return styles.Blue;
    }
  };

  return (
    <button type="button" className={`${styles.Widget} ${getClassName()}`} onClick={() => navigate(link)}>
      <div className={styles.TopLine}>
        <Header icon={icon} name={name} color={color} />
        <span className={styles.Arrow}><IconWrapper icon={FaArrowRight} /></span>
      </div>
      <p className={styles.Subtitle}>{subtitle}</p>
      <div className={styles.Stats}>
        {Object.keys(values).map((k, i) => (
          <div key={i} className={styles.Number}>
            <div className={styles.Label}>{k}</div>
            <span className={styles.Value}>{values[k]}</span>
          </div>
        ))}
      </div>
    </button>
  );
};

export default Widget;
